import gql from 'graphql-tag';

const DISCOVERY_CATEGORIES = gql`
  query {
    discovery_categories {
      id
      name
    }
  }
`;

const DISCOVERY_FAVORITES = gql`
  query {
    discovery_articles_student_liked {
      id
      title
      image_url
      content
    }
  }
`;

const DISCOVERY_MATERIAL =  gql`
  query DiscoveryArticle($student_book_id: Int!) {
    discovery_article(student_book_id: $student_book_id) {
        id
        title
        author
        recommended_level
        image_url
        content
    }
  }
`;

const DISCOVERY_MATERIAL_MSB =  gql`
  query DiscoveryArticle($student_book_id: Int!) {
    discoveryArticle(student_book_id: $student_book_id) {
        id
        title
        author
        recommended_level
        image_url
        content
    }
  }
`;

export {
  DISCOVERY_CATEGORIES, 
  DISCOVERY_FAVORITES, 
  DISCOVERY_MATERIAL,
  DISCOVERY_MATERIAL_MSB
};
